
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/en/imprint",
      function () {
        return require("private-next-pages/de/en/imprint.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/en/imprint"])
      });
    }
  